'use es6';

import get from 'transmute/get';
export const getWidgetDataAsyncData = state => get('widgetData', state);